<div class="conatct-address" *ngIf="!childConfig.isHidden" [style.width.px]="childConfig.css.width">
    <div class="tml-tpl-ctrl-wrap">
        <!--address key-->
        <div class="tam-contact-control" tid="Address_Type">
            <kendo-dropdownlist [style.width.px]="childConfig.css.leftWidth" [(ngModel)]="valueAddressType"
                [data]="valueAddressTypeList" (valueChange)="changeValueAddressType($event)" #dropDownkey
                (focus)="dropDownkey.toggle(true)" (mousedown)="$event.preventDefault()">
            </kendo-dropdownlist>
        </div>
        <!--country-->
        <div class="tam-contact-control" tid="Address_Country">
            <kendo-combobox #dropDownCountry [style.width.px]="childConfig.css.rightWidth" [(ngModel)]="valueCountry"
                [data]="valueCountryList" (valueChange)="changeValueCountry($event)" placeholder="country/region"
                (focus)="dropDownCountry.toggle(true)" [allowCustom]="isCustom">
            </kendo-combobox>
        </div>
        <div class="trash-icon">
            <smart-icon *ngIf="childConfig.config.isCanDelete" name="trash" (click)="clickRemoveLayout($event)">
            </smart-icon>
        </div>
    </div>
    <div class="tml-tpl-ctrl-wrap">
        <!--useless-->
        <div class="tam-contact-control" [style.visibility]="'hidden'">
            <input class="tam-input" [style.width.px]="childConfig.css.leftWidth"
                [style.heightt.px]="childConfig.height" />
        </div>
        <!--street1-->
        <div class="tam-contact-control street" kendoTooltip position="right" tooltipClass="tooltip-adjust-right"
            tid="Address_Street1">
            <div>
                <input class="tam-input" [style.width.px]="childConfig.css.rightWidth" [(ngModel)]="valueStreet"
                    (ngModelChange)="changeValueStreet($event)" placeholder="street1" [maxLength]="1024" />
                <smart-icon title="Address lookup" class="contact-street"
                    [name]="isShowSearchAddress?'searchAddress':'searchAddress-o'" (click)="clickSearchAddress()">
                </smart-icon>
            </div>
            <tam-dashboard-map-autocomplete *ngIf="isShowSearchAddress" class="contact-autocomplete"
                [config]="mapConfig" (eventSubject$)="setSelectedAddress($event)">
            </tam-dashboard-map-autocomplete>
            <label class="item-label-error">
                {{hintContentStreet}}
            </label>
        </div>
        <div>
            <span *ngIf="childConfig.config.isRequired" style="color:red;">*</span>
        </div>
    </div>
    <div class="tml-tpl-ctrl-wrap">
        <!--useless-->
        <div class="tam-contact-control" [style.visibility]="'hidden'">
            <input class="tam-input" [style.width.px]="childConfig.css.leftWidth"
                [style.heightt.px]="childConfig.height" placeholder="street" />
        </div>
        <!--street2-->
        <div class="tam-contact-control street" tid="Address_Street2">
            <input class="tam-input" [style.width.px]="childConfig.css.rightWidth" [(ngModel)]="valueStreet2"
                (ngModelChange)="changeValueStreet2($event)" placeholder="street2" [maxLength]="1024" />
        </div>
    </div>
    <div class="tml-tpl-ctrl-wrap">
        <!-- useless-->
        <div class="tam-contact-control" [style.visibility]="'hidden'">
            <input class="tam-input" [style.width.px]="childConfig.css.leftWidth"
                [style.heightt.px]="childConfig.height" />
        </div>
        <!--city-->
        <div class="tam-contact-control tam-relative" tid="Address_City">
            <input class="tam-input" [style.width.px]="cityWidth" [style.heightt.px]="childConfig.height"
                [(ngModel)]="valueCity" (ngModelChange)="changeValueCity($event)" placeholder="city" />
            <label class="item-label-error">
                {{hintContentCity}}
            </label>
            <div class="address-required-icon">
                <span *ngIf="childConfig.config.isRequired" style="color:red;">*</span>
            </div>
        </div>

        <!--state-->
        <div class="tam-contact-control tam-relative" tid="Address_Province">
            <kendo-combobox #dropDownState [style.width.px]="cityWidth" [(ngModel)]="valueState" [data]="valueStateList"
                (valueChange)="changeValueState($event)" placeholder="state/province"
                (focus)="dropDownState.toggle(true)" [allowCustom]="isCustom" [filterable]="true"
                (filterChange)="filterChange($event)">
            </kendo-combobox>

            <label class="item-label-error">
                {{hintContentState}}
            </label>
            <div class="address-required-icon">
                <span *ngIf="childConfig.config.isRequired" style="color:red;">*</span>
            </div>
        </div>

        <!--zip-->
        <div class="tam-contact-control" tid="Address_Zip">
            <input class="tam-input" [style.width.px]="cityWidth" [style.heightt.px]="childConfig.height"
                (ngModelChange)="changeValueZip($event)" placeholder="zip" [(ngModel)]="valueZip" />
        </div>
    </div>
    <div *ngIf="childConfig.config.isSupportDynamic" class="label-bac" (click)="clickAddCtrol()">
        <label>{{childConfig.config.addlabel}}</label>
    </div>
</div>